/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Certificatetemplate1Inputs */

const en__field_certificatetemplate1 = /** @type {(inputs: _Field_Certificatetemplate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificate template`)
};

const de__field_certificatetemplate1 = /** @type {(inputs: _Field_Certificatetemplate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zertifikat Vorlage`)
};

/**
* | output |
* | --- |
* | "Certificate template" |
*
* @param {_Field_Certificatetemplate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_certificatetemplate1 = /** @type {((inputs?: _Field_Certificatetemplate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Certificatetemplate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_certificatetemplate1(inputs)
	return de__field_certificatetemplate1(inputs)
});
export { _field_certificatetemplate1 as "_field_certificateTemplate" }